import { find, get, isArray } from "lodash";
import moment from "moment";
import { all, call, fork, put, select, takeLatest } from "redux-saga/effects";
import { openToast } from "~/components/common/molecules/ToastNotification";
import history from "~/history";
import * as api from "~/store/booking/bookingApi";
import * as types from "~/store/booking/bookingType";
import * as notiAction from "~/store/notifications/notificationsActions";
import * as healthInsuranceCardTypes from "~/store/payment/paymentType"; // chỗ này chưa move vào store
// import * as notiActions from "~/store/notifications/notificationsActions";
import * as totalDataTypes from "~/store/totalData/types";
import { huyi } from "~/utils/clog";
import { getBaseUrl } from "~/utils/getBaseUrl";
import { client } from "~/utils/medproSDK";
import { UPDATE_CANCEL_BILL } from "../customerService/customerServiceTypes";
import { getBookingInfo } from "../totalData/actions";
import * as actions from "./bookingAction";
import { getDataToReserve } from "~/utils/func";

function* hiddenBill({ id }) {
  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";
    const response = yield client.invisibleBooking({ id }, { platform });

    if (response) {
      const { data } = response;
      yield put({ type: types.HIDDEN_BILL_SUCCESS, data });
    }
  } catch (error) {
    yield put({ type: types.HIDDEN_BILL_FAIL, error });
  }
}

function* watchHiddenBill() {
  yield takeLatest(types.HIDDEN_BILL, hiddenBill);
}

// medical bills
function* getMedicalBills(data) {
  try {
    const baseUrl = yield select(state => getBaseUrl(state.hospital));
    const response = yield call(api.getMedicalBills, baseUrl, data);
    if (response.status !== 200 || response.data.error_code)
      throw new Error("Lỗi server!");
    if (response) {
      const { data } = response;
      yield put({ type: types.GET_MEDICAL_BILLS_SUCCESS, data });
    }
  } catch (error) {
    yield put({ type: types.GET_MEDICAL_BILLS_FAILURE, error });
  }
}

function* watchGetMedicalBills() {
  yield takeLatest(types.GET_MEDICAL_BILLS, getMedicalBills);
}

// medical bill detail
function* getMedicalBillDetail(data) {
  try {
    const baseUrl = yield select(state => getBaseUrl(state.hospital));
    const response = yield call(api.getMedicalBillDetail, baseUrl, data);
    if (response.status !== 200 || response.data.error_code)
      throw new Error("Lỗi server!");
    if (response) {
      const { data } = response;
      yield put({ type: types.GET_MEDICAL_BILL_DETAIL_SUCCESS, data });
    }
  } catch (error) {
    yield put({ type: types.GET_MEDICAL_BILL_DETAIL_FAILURE, error });
  }
}

function* watchGetMedicalBillDetail() {
  yield takeLatest(types.GET_MEDICAL_BILL_DETAIL, getMedicalBillDetail);
}

// cancel medical bill
function* cancelMedicalBill({ id, partnerId }) {
  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";
    const customerService = yield select(state => state.customerService);
    const listBooking = customerService.phoneSearchResult.bookings;

    const token = yield select(state => state.user.info.token);
    const response = yield client.cancelBooking(
      {
        id: id
      },
      {
        partnerid: partnerId,
        token,
        cskhtoken: customerService.cskhToken,
        platform
      }
    );

    const { data } = response;

    // const data = data_huy_phieu_kham;

    yield put({
      type: types.CANCEL_MEDICAL_BILL_SUCCESS,
      data
    });

    yield put({
      type: totalDataTypes.GET_ALL_MEDICAL_BILLS
    });

    if (isArray(data)) {
      const arrTrans = data.map(item => item.transactionId);
      const listBookings = listBooking.map(item => {
        if (arrTrans.includes(item.transactionId)) {
          const findItem = find(data, { transactionId: item.transactionId });
          if (findItem) {
            return {
              ...item,
              status: findItem?.status,
              description: findItem?.description
            };
          } else {
            return item;
          }
        } else {
          return item;
        }
      });

      yield put({
        type: UPDATE_CANCEL_BILL,
        booking: listBookings
      });
    } else {
      const transId = get(data, "transactionId");
      yield put(getBookingInfo({ transactionId: transId }));

      // cập nhật lại trạng thái booking
      const indexBooking = listBooking.findIndex(
        m => m.transactionId === transId
      );

      listBooking[indexBooking] = {
        ...listBooking[indexBooking],
        status: data.status,
        description: data.description
      };

      yield put({
        type: UPDATE_CANCEL_BILL,
        booking: listBooking
      });
    }
  } catch (error) {
    const message = get(error, "response.data.message", "");
    console.log("error : >>", error);
    openToast(message, "error");
    yield put({ type: types.CANCEL_MEDICAL_BILL_FAILURE, error });
  } finally {
    yield put(notiAction.getNotificationOnPage({ category: 1 }));
  }
}

function* watchCancelMedicalBill() {
  yield takeLatest(types.CANCEL_MEDICAL_BILL, cancelMedicalBill);
}

// resend sms
function* resendSMS(submitData) {
  try {
    const baseUrl = yield select(state => getBaseUrl(state.hospital));
    const response = yield call(api.resendSMS, baseUrl, submitData);
    if (response.status !== 200 || response.data.error_code)
      throw new Error("Lỗi server!");
    const { data } = response;
    if (typeof data.error_code === typeof undefined) {
      const message = "Gửi SMS thành công";
      yield put({ type: types.RESEND_SMS_SUCCESS, data });
      yield put({
        type:
          healthInsuranceCardTypes.TOGGLE_RESEND_SMS_MODAL_HEALTH_INSURANCE_CARD
      });
      yield put({
        type:
          healthInsuranceCardTypes.SHOW_RESEND_SMS_OK_MODAL_HEALTH_INSURANCE_CARD,
        message
      });
    } else {
      const message = "Bạn chỉ gởi được 2 tin nhắn cho mỗi phiếu khám bệnh.";
      yield put({
        type:
          healthInsuranceCardTypes.TOGGLE_RESEND_SMS_MODAL_HEALTH_INSURANCE_CARD
      });
      yield put({
        type:
          healthInsuranceCardTypes.SHOW_RESEND_SMS_OK_MODAL_HEALTH_INSURANCE_CARD,
        message
      });
    }
  } catch (error) {
    const message = "Có lỗi xảy ra.";
    yield put({ type: types.RESEND_SMS_FAILURE, error });
    yield put({
      type:
        healthInsuranceCardTypes.TOGGLE_RESEND_SMS_MODAL_HEALTH_INSURANCE_CARD
    });
    yield put({
      type:
        healthInsuranceCardTypes.SHOW_RESEND_SMS_OK_MODAL_HEALTH_INSURANCE_CARD,
      message
    });
  }
}

function* watchResendSMS() {
  yield takeLatest(types.RESEND_SMS, resendSMS);
}

function* submitBooking({ postData }) {
  try {
    yield put(actions.loadingSubmitBooking());
    const baseUrl = yield select(state => getBaseUrl(state.hospital));
    const response = yield call(api.submitBooking, baseUrl, postData);
    const { data } = response;
    if (data.error_code) throw Error(data.error_message);
    yield put(actions.submitBookingSuccess(data));
    if (
      data.payment_url &&
      postData.method_id !== 6 &&
      postData.method_id !== 5
    ) {
      window.location.href = data.payment_url;
    }
  } catch (error) {
    yield put(actions.submitBookingFail(error));
  }
}

function* watchSubmitBooing() {
  yield takeLatest(types.SUBMIT_BOOKING, submitBooking);
}

function* updateBooking() {
  try {
    yield put(actions.loadingUpdateBooking());
    const totalData = yield select(state => state.totalData);
    const partnerid = yield select(state => state.totalData.partnerId);
    const patient = yield select(state => state.patient);
    const user = yield select(state => state.user);
    const bookingInfos = get(totalData, "schedulesSelected", null);
    const booking = bookingInfos.length > 0 ? bookingInfos[0] : null;
    const global = yield select(state => state.global);
    const paymentMethod = yield select(state => state.payment);
    const reExamReducer = yield select(state => state.followUpExam);

    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";
    const { cskhToken, selectedBill } = yield select(
      state => state.customerService
    );

    const date = get(booking, "date", 0);
    const formatDate = moment(date).format("YYYY-MM-DD");
    const startTime = get(booking, "time.startTime", "");
    const dateString = moment(formatDate + " " + startTime).toISOString() || "";

    const dataToReserve = getDataToReserve(
      totalData,
      global,
      paymentMethod,
      patient,
      reExamReducer
    );

    const postData = {
      ...dataToReserve,
      bookingId: selectedBill?.bookingInfo?.id,
      patientId: patient?.selectedPatientId,
      serviceId: booking.service?.id,
      subjectId: booking.subject?.id,
      roomId: booking.room?.id,
      doctorId: booking.doctor?.id,
      date: dateString
    };

    const header = {
      partnerid: partnerid,
      platform,
      cskhToken,
      token: user?.info?.token
    };
    // console.log('postData :>> ', postData);

    const debug = localStorage.getItem("debug");
    if (!debug) {
      const respone = yield client.updateBooking(postData, header);
      const { transactionId } = respone.data;
      yield put(actions.updateBookingSuccess());
      const urlCsBooking =
        "/cskh/booking?mpTransaction=" +
        `${transactionId || selectedBill?.transactionId}`;
      history.push(urlCsBooking);
    } else {
      console.log("postData: ", postData);
      console.log("header: ", header);
      yield put(actions.updateBookingSuccess());
    }
  } catch (error) {
    yield put(actions.updateBookingFail());
    huyi({ name: "updateBooking", child: error });
    const message = get(
      error,
      "response.data.message",
      "Lỗi cập nhật phiếu khám!"
    );
    openToast(message, "error");
  }
}

function* watchUpdateBooking() {
  yield takeLatest(types.UPDATE_BOOKING, updateBooking);
}

function* getMedproCareSaga(action) {
  try {
    const cs = yield select(state => state.customerService);
    const cskhToken = cs?.selectedPatient?.secretKey;
    const jwtCS = window.localStorage.getItem("cskhToken");
    const data = yield call(api.fetchMedproCareByRules, action.payload, {
      cskhToken: cskhToken || jwtCS
    });

    yield put({
      type: types.SET_MEDPRO_CARE,
      data
    });
    // yield put(types.SELECT_MEDPRO_CARE, { payload: undefined });
  } catch (e) {
    console.log("Không có thông tin Medpro Care");
    yield put({
      type: types.SET_MEDPRO_CARE,
      data: {
        id: "",
        name: "",
        note: "",
        addonServices: []
      }
    });
  }
}

function* watcher_getMedproCareSaga() {
  yield takeLatest(types.GET_MEDPRO_CARE, getMedproCareSaga);
}

export default function* root() {
  yield all([
    fork(watchGetMedicalBills),
    fork(watchGetMedicalBillDetail),
    fork(watchCancelMedicalBill),
    fork(watchResendSMS),
    fork(watchSubmitBooing),
    fork(watchHiddenBill),
    fork(watchUpdateBooking),
    fork(watcher_getMedproCareSaga)
  ]);
}
